import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { OnlineUsersCounter } from '../components/OnlineUsersCounter';
import { PurchasePopup } from '../components/PurchasePopup';
export function SalesPage() {
  return <div className="min-h-screen bg-cream-100 flex flex-col font-sans" data-id="element-193">
      <Header data-id="element-194" />
      <main className="flex-grow" data-id="element-195">
        <HeroSection data-id="element-196" />
        <PainSection data-id="element-197" />
        <SolutionSection data-id="element-198" />
        <PricingSection data-id="element-199" />
        <TestimonialsSection data-id="element-200" />
        <GuaranteeSection data-id="element-201" />
        <FAQSection data-id="element-202" />
      </main>
      <Footer data-id="element-203" />

      {/* Floating Elements */}
      <OnlineUsersCounter data-id="element-204" />
      <PurchasePopup data-id="element-205" />
    </div>;
}